// extracted by mini-css-extract-plugin
export var dark = "y_tn";
export var darkcookie = "y_tp";
export var tintedcookie = "y_tq";
export var regularcookie = "y_tr";
export var darkbase = "y_ts";
export var tintedbase = "y_tt";
export var regularbase = "y_tv";
export var darkraw = "y_tw";
export var tintedraw = "y_tx";
export var regularraw = "y_ty";
export var darkchick = "y_tz";
export var tintedchick = "y_tB";
export var regularchick = "y_tC";
export var darkherbarium = "y_tD";
export var tintedherbarium = "y_tF";
export var regularherbarium = "y_tG";
export var darkholiday = "y_tH";
export var tintedholiday = "y_tJ";
export var regularholiday = "y_tK";
export var darkoffline = "y_tL";
export var tintedoffline = "y_tM";
export var regularoffline = "y_tN";
export var darkorchid = "y_tP";
export var tintedorchid = "y_tQ";
export var regularorchid = "y_tR";
export var darkpro = "y_tS";
export var tintedpro = "y_tT";
export var regularpro = "y_tV";
export var darkrose = "y_tW";
export var tintedrose = "y_tX";
export var regularrose = "y_tY";
export var darktimes = "y_tZ";
export var tintedtimes = "y_t0";
export var regulartimes = "y_t1";
export var darkwagon = "y_t2";
export var tintedwagon = "y_t3";
export var regularwagon = "y_t4";